module.exports = __webpack_public_path__ + "media/images/smart_phone/shares/202001/logo_blank-fab1870ee62621b2ed186176dda89668.png";